import React, { useContext } from 'react';
import { LocalizationProvider } from '@bynder/localization';
import { englishText } from './englishText';
import { InfoContext } from '../../context';

interface Props {
	children: React.ReactNode;
}

export function Localization({ children }: Props) {
	const { languages } = useContext(InfoContext);

	function fetchFallback(): Promise<Record<string, string>> {
		return new Promise((resolve) => {
			resolve(englishText);
		});
	}

	return (
		<LocalizationProvider
			addCustomTranslations
			locale={languages.selected}
			project="header-frontend"
			fetchFallback={fetchFallback}
		>
			{children}
		</LocalizationProvider>
	);
}
